const switches = {
  on: 'on',
  off: 'off',
}
export default switches
